import SkeletonProductCard from '../../components/skeletons/ProductCard';
import React from 'react';
import { PRODUCT_PER_PAGE } from '../../utils/constants/product';

export default function SkeletonCategory() {
    return (
        <div className="mt-10 grid gap-y-10 gap-x-6 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:gap-x-6">
            {[...new Array(PRODUCT_PER_PAGE)].map((value, index) => (
                <SkeletonProductCard key={index} />
            ))}
        </div>
    );
}
